import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/** Shown when the user opened this page from Settings hub. */
const SettingsBackButton: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const fromSettings = Boolean(
    (location.state as { fromSettings?: boolean } | null)?.fromSettings
  );

  if (!fromSettings) return null;

  return (
    <button
      type="button"
      onClick={() => navigate('/settings')}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
        marginBottom: '12px',
        padding: 0,
        border: 'none',
        background: 'none',
        color: '#64748b',
        fontSize: '13px',
        fontWeight: 500,
        cursor: 'pointer',
        fontFamily: 'inherit',
      }}
    >
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="19" y1="12" x2="5" y2="12" />
        <polyline points="12 19 5 12 12 5" />
      </svg>
      Back to Settings
    </button>
  );
};

export default SettingsBackButton;
